// src/store/bookReviewSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import BookReviewManager from '../services/home/BookReviewManager';

// Initial State
const initialState = {
  reviewsByBook: {},  // ✅ normalized state
  status: 'idle',
  error: null,
};

export const fetchReviewsByBook = createAsyncThunk(
  'bookReview/fetchReviewsByBook',
  async (bookId) => {
    const reviews = await BookReviewManager.getReviewsByBook(bookId);
    return { bookId, reviews };
  }
);

export const addReview = createAsyncThunk(
  'bookReview/addReview',
  async ({ userId, bookId, rating, review }) => {
    const newReview = await BookReviewManager.addReview(userId, bookId, rating, review);
    return { bookId, review: newReview };
  }
);

const bookReviewSlice = createSlice({
  name: 'bookReview',
  initialState,
  reducers: {
    resetBookReviews: (state) => {
      state.reviewsByBook = {};
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReviewsByBook.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchReviewsByBook.fulfilled, (state, { payload }) => {
        const { bookId, reviews } = payload;
      
        if (typeof state.reviewsByBook !== 'object' || Array.isArray(state.reviewsByBook)) {
          state.reviewsByBook = {};
        }
      
        state.status = 'succeeded';
        state.reviewsByBook[bookId] = reviews; // reviews might be empty — that's OK!
      })

      .addCase(fetchReviewsByBook.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })

      .addCase(addReview.fulfilled, (state, { payload }) => {
        const { bookId, review } = payload;
        if (!state.reviewsByBook[bookId]) {
          state.reviewsByBook[bookId] = [];
        }
        state.reviewsByBook[bookId].push(review);
      });
  },
});

export const { resetBookReviews } = bookReviewSlice.actions;
export default bookReviewSlice.reducer;

